'use client'

import React, { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'
import Link from '@/components/link'
import Modal from '@/components/modal'
import Button from '@/components/button'
import styles from './IconModal.module.css'

const IconModal: FC<
	PropsWithChildren<{
		open: boolean
		rootClassName?: string
		icon: FC<{ className?: string; width?: number | string; height?: number }>
		iconClassName?: string
		iconContainerClassName?: string
		title: string
		titleClassName?: string
		description?: string
		descriptionClassName?: string
		subDescription?: string
		subDescriptionLink?: string
		subDescriptionClassName?: string
		bodyClassName?: string
		onClose: (evt: any) => void
		footerButtonText?: string
	}>
> = (props): ReactElement => {
	const {
		title,
		description,
		rootClassName,
		iconClassName,
		titleClassName,
		descriptionClassName,
		bodyClassName,
		subDescription,
		subDescriptionClassName,
		subDescriptionLink,
		iconContainerClassName,
		footerButtonText
	} = props

	return (
		<Modal open={props.open} onClose={props.onClose}>
			<div className={classNames({ [(props.rootClassName as any)]: !!rootClassName }, styles.root)}>
				<div
					className={classNames(
						{ [(props.iconContainerClassName as any)]: !!iconContainerClassName },
						styles.icon
					)}
				>
					<props.icon
						className={classNames({ [(props.iconClassName as any)]: !!iconClassName }, styles.icon)}
					/>
				</div>
				<p
					className={classNames(
						{ [(props.titleClassName as any)]: !!titleClassName },
						styles.title,
						'text-lg',
						'semibold'
					)}
				>
					{title}
				</p>
				{description && (
					<p
						className={classNames(
							{ [(props.descriptionClassName as any)]: !!descriptionClassName },
							styles.description,
							'text-sm',
							'regular'
						)}
					>
						{description}
					</p>
				)}
				{subDescription && subDescriptionLink && (
					<Link
						className={classNames(
							{ [(props.subDescriptionClassName as any)]: !!subDescriptionClassName },
							styles.subDescription,
							'text-sm',
							'regular'
						)}
						href={subDescriptionLink}
						target="_blank"
					>
						{subDescription}
					</Link>
				)}
				<div className={classNames({ [(props.bodyClassName as any)]: !!bodyClassName }, styles.body)}>
					{props.children}
				</div>
				{footerButtonText && (
					<Button
						onClick={props.onClose}
						className={styles.button}
						background={'transparent'}
						size={'large'}
					>
						{footerButtonText}
					</Button>
				)}
			</div>
		</Modal>
	)
}

export default IconModal
